import { useDraggable } from "@dnd-kit/core";

/**
 * Wrapper que torna o ContactCard arrastável no desktop.
 * Em mobile (ou com disabled=true) só renderiza o filho — mantém o comportamento atual.
 * - activationConstraint distance=6px no PointerSensor garante que um clique curto
 *   não dispara drag; abre o card normalmente.
 * - data-dnd-handle sinaliza para o KanbanBoard não iniciar o pan-scroll.
 */
export function DraggableCard({ contact, disabled, children }) {
  const { attributes, listeners, setNodeRef, isDragging } = useDraggable({
    id: contact.id,
    data: { contact },
    disabled,
  });

  if (disabled) return <>{children}</>;

  const style = isDragging ? { opacity: 0.25, cursor: "grabbing" } : { cursor: "grab" };
  return (
    <div
      ref={setNodeRef}
      style={style}
      data-dnd-handle="1"
      {...listeners}
      {...attributes}
    >
      {children}
    </div>
  );
}
